import { render, staticRenderFns } from "./CollectionDataForm.vue?vue&type=template&id=01f48150&"
import script from "./CollectionDataForm.vue?vue&type=script&lang=js&"
export * from "./CollectionDataForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDataForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports